import { useEffect } from 'react';
import Image from 'next/image'
interface ScrollToElementProps {
  targetId: string;
  buttonClassName: string;
}

const ScrollToElement: React.FC<ScrollToElementProps> = ({ targetId, buttonClassName }) => {
  const handleScrollToTarget = () => {
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      if (window.outerWidth < 992) {
        window.scrollTo({
          top: targetElement.offsetTop - 40,
          behavior: 'smooth',
        });
      } else {
        window.scrollTo({
          top: targetElement.offsetTop,
          behavior: 'smooth',
        });
      }
    }
  };

  useEffect(() => {
    const scrollButton = document.querySelector(`.${buttonClassName}`);

    if (scrollButton) {
      scrollButton.addEventListener('click', handleScrollToTarget);
    }

    return () => {
      if (scrollButton) {
        scrollButton.removeEventListener('click', handleScrollToTarget);
      }
    };
  }, []);

  return (
    <div  className="scroll_down">
        <button  className={buttonClassName}>
            <Image src="/images/tringle-down.svg" alt="down" width={101} height={61} />
        </button>
    </div>
  );
};

export default ScrollToElement;
